(function () {
  var STORAGE_KEY = 'fb_attr_hub_attribution_v1';
  var LAST_WRITE_KEY = 'fb_attr_hub_cart_write_v1';
  var ATTRIBUTION_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var WRITE_THROTTLE_MS = 60 * 1000;
  var FIELDS = [
    'utm_source',
    'utm_medium',
    'utm_id',
    'utm_campaign',
    'utm_campaign_id',
    'campaign_id',
    'utm_adset',
    'utm_adset_id',
    'adset_id',
    'utm_ad',
    'utm_ad_id',
    'ad_id',
    'utm_content',
    'utm_term',
    'utm_placement',
    'utm_site',
    'lp',
    'px',
    'px_id',
    'fbclid'
  ];
  var ATTR_NAMES = {
    utm_source: '__fbah_utm_source',
    utm_medium: '__fbah_utm_medium',
    utm_id: '__fbah_utm_id',
    utm_campaign: '__fbah_utm_campaign',
    utm_campaign_id: '__fbah_utm_campaign_id',
    campaign_id: '__fbah_campaign_id',
    utm_adset: '__fbah_utm_adset',
    utm_adset_id: '__fbah_utm_adset_id',
    adset_id: '__fbah_adset_id',
    utm_ad: '__fbah_utm_ad',
    utm_ad_id: '__fbah_utm_ad_id',
    ad_id: '__fbah_ad_id',
    utm_content: '__fbah_utm_content',
    utm_term: '__fbah_utm_term',
    utm_placement: '__fbah_utm_placement',
    utm_site: '__fbah_utm_site',
    lp: '__fbah_lp',
    px: '__fbah_px',
    px_id: '__fbah_px_id',
    fbclid: '__fbah_fbclid'
  };

  function readQuery(search) {
    var out = {};
    try {
      var params = new URLSearchParams(search || '');
      params.forEach(function (value, key) {
        out[key] = value;
      });
    } catch (_) {}
    return out;
  }

  function compactAttribution(value) {
    var out = {};
    FIELDS.forEach(function (key) {
      if (value && value[key]) out[key] = String(value[key]);
    });
    return out;
  }

  function firstPresent(value, keys) {
    for (var i = 0; i < keys.length; i += 1) {
      var text = String((value && value[keys[i]]) || '').trim();
      if (text) return text;
    }
    return '';
  }

  function hasAdAttribution(value) {
    return Boolean(
      value && (
        value.fbclid ||
        value.px_id ||
        value.px ||
        value.lp ||
        value.utm_id ||
        value.utm_campaign_id ||
        value.campaign_id ||
        value.utm_ad_id ||
        value.ad_id ||
        value.utm_source === 'facebook'
      )
    );
  }

  function hasCompleteRoute(value) {
    return Boolean(value && value.lp && value.px_id);
  }

  function hasMatchingJourneyIdentity(current, stored) {
    var pairs = [
      [current && current.fbclid, stored && stored.fbclid],
      [firstPresent(current, ['utm_campaign_id', 'campaign_id', 'utm_id']), firstPresent(stored, ['utm_campaign_id', 'campaign_id', 'utm_id'])],
      [firstPresent(current, ['utm_adset_id', 'adset_id', 'utm_term']), firstPresent(stored, ['utm_adset_id', 'adset_id', 'utm_term'])],
      [firstPresent(current, ['utm_ad_id', 'ad_id', 'utm_content']), firstPresent(stored, ['utm_ad_id', 'ad_id', 'utm_content'])]
    ];
    return pairs.some(function (pair) {
      return pair[0] && pair[1] && pair[0] === pair[1];
    });
  }

  function readStoredAttribution() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return {};
      var stored = JSON.parse(raw);
      if (!stored.savedAt || Date.now() - Number(stored.savedAt) > ATTRIBUTION_TTL_MS) {
        window.localStorage.removeItem(STORAGE_KEY);
        return {};
      }
      return stored.attribution || {};
    } catch (_) {
      return {};
    }
  }

  function saveStoredAttribution(attribution) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        savedAt: Date.now(),
        landingPageUrl: window.location.href || '',
        attribution: attribution
      }));
    } catch (_) {}
  }

  function resolveAttribution(current, stored) {
    if (hasCompleteRoute(current)) return { attribution: current, save: true };
    if (hasAdAttribution(current)) {
      if (hasCompleteRoute(stored) && hasMatchingJourneyIdentity(current, stored)) {
        return {
          attribution: Object.assign({}, stored, current, {
            lp: stored.lp,
            px: stored.px,
            px_id: stored.px_id
          }),
          save: true
        };
      }
      return { attribution: current, save: true };
    }
    return { attribution: stored, save: false };
  }

  function canTrack() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;
    try {
      var analytics = typeof privacy.analyticsProcessingAllowed === 'function'
        ? privacy.analyticsProcessingAllowed()
        : true;
      var marketing = typeof privacy.marketingAllowed === 'function'
        ? privacy.marketingAllowed()
        : true;
      return Boolean(analytics || marketing);
    } catch (_) {
      return true;
    }
  }

  function limit(value, max) {
    return String(value || '').trim().slice(0, max || 250);
  }

  function signature(attribution) {
    return FIELDS.map(function (key) {
      return key + '=' + limit(attribution[key], 500);
    }).join('&');
  }

  function cartUpdateUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart/update.js';
  }

  function shouldSkipWrite(sig, force) {
    if (force) return false;
    try {
      var raw = window.localStorage.getItem(LAST_WRITE_KEY);
      if (!raw) return false;
      var last = JSON.parse(raw);
      return last.signature === sig && Date.now() - Number(last.writtenAt || 0) < WRITE_THROTTLE_MS;
    } catch (_) {
      return false;
    }
  }

  function rememberWrite(sig) {
    try {
      window.localStorage.setItem(LAST_WRITE_KEY, JSON.stringify({
        signature: sig,
        writtenAt: Date.now()
      }));
    } catch (_) {}
  }

  function buildAttributes(attribution) {
    var attributes = {
      __fbah_route_ts: new Date().toISOString(),
      __fbah_landing_url: limit(window.location.href || '', 1000)
    };
    FIELDS.forEach(function (key) {
      if (attribution[key]) attributes[ATTR_NAMES[key]] = limit(attribution[key], key === 'fbclid' ? 500 : 250);
    });
    return attributes;
  }

  function flush(force) {
    if (!canTrack()) return Promise.resolve(false);
    var current = compactAttribution(readQuery(window.location.search || ''));
    var stored = readStoredAttribution();
    var resolved = resolveAttribution(current, stored);
    if (resolved.save) saveStoredAttribution(resolved.attribution);
    if (!hasCompleteRoute(resolved.attribution)) return Promise.resolve(false);

    var sig = signature(resolved.attribution);
    if (shouldSkipWrite(sig, Boolean(force))) return Promise.resolve(false);
    rememberWrite(sig);

    return window.fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: buildAttributes(resolved.attribution) })
    }).then(function (response) {
      if (!response || !response.ok) rememberWrite('');
      return Boolean(response && response.ok);
    }).catch(function () {
      rememberWrite('');
      return false;
    });
  }

  function maybeFlushForCheckout(event) {
    var target = event && event.target;
    if (!target || !target.closest) return;
    var node = target.closest('a,button,input,form');
    if (!node) return;
    var text = String(node.textContent || node.value || node.name || '').toLowerCase();
    var href = String(node.href || node.action || '').toLowerCase();
    if (href.indexOf('/checkout') !== -1 || text.indexOf('checkout') !== -1 || text.indexOf('check out') !== -1) {
      flush(true);
    }
  }

  flush(false);
  window.addEventListener('pageshow', function () { flush(false); });
  document.addEventListener('submit', maybeFlushForCheckout, true);
  document.addEventListener('click', maybeFlushForCheckout, true);
  document.addEventListener('visitorConsentCollected', function () { flush(true); });
})();

